<script>
   import { lge } from './store.js';
   import { createEventDispatcher } from 'svelte';
   lge.useLocalStorage();
   const dispatch = createEventDispatcher();
</script>

<style>
		
	.block {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
    }
	
    button {
    border: none;
    border-radius: 15px;
	  color: white;
	  padding: 12px;
	  text-align: center;
	  text-decoration: none;
	  display: inline-block;
	  font-size: 16px;
	  margin: 6px 4px;
    }
    
    .bon {
      background-color : #0cd1e8;
    }

    .boff {
      background-color: #3880ff;
    }

</style>

<div class="block">
    <button class="button {$lge === 0 ? 'bon' : 'boff'}" on:click={() => {$lge=0; dispatch('LgeUpd')}}>Club 55</button>
    <button class="button {$lge === 5 ? 'bon' : 'boff'}" on:click={() => {$lge=5; dispatch('LgeUpd')}}>Mid-Week</button>
	  <button class="button {$lge === 10 ? 'bon' : 'boff'}" on:click={() => {$lge=10; dispatch('LgeUpd')}}>Week-End</button>
</div>
